{
	"transactionCardHeader": "Waliduj transakcję",
	"transactionCardDescriptionBold": "Chcesz zwalidować transakcję dla dowolnego projektu?",
	"transactionCardDescriptionRegular": "Jeśli masz pod ręką numer transakcji, możesz wprowadzić go tutaj i zwalidować transakcję.",
	"showTransactionButton": "Pokaż transakcję",
	"transactionLabel": "Numer transakcji",
	"errors": {
		"transactionIdRequired": "Numer transakcji jest wymagany.",
		"transactionNotFound": "Nie znaleziono transakcji.",
		"transactionIdInvalid": "Nieprawidłowy numer transakcji."
	}
}
